import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useSettings} from '../../../../hooks/settings'
import settingsParams from '../../../../settingsParams'
import {useAppActions, useAppSelector} from '../../../hooks/runtime'
import {useVisibilityStyles} from '../../../hooks/use-visibility-styles'
import {getScheduleItems, getScheduleItemsTotal} from '../../../selectors/schedule'
import {Subtitle} from '../../subtitle/subtitle'
import {Footer} from './footer'
import {List} from './list'
import s from './schedule.scss'

export const Schedule = () => {
  const {t} = useTranslation()
  const {
    allBreakpoints: {isScheduleVisible},
  } = useVisibilityStyles()
  const settings = useSettings()
  const {navigateToSchedulePage} = useAppActions()

  const items = useAppSelector(getScheduleItems)
  const total = useAppSelector(getScheduleItemsTotal)

  return isScheduleVisible() ? (
    <div className={s.container} data-hook={DH.SCHEDULE}>
      <Subtitle dataHook={DH.SCHEDULE_SUBTITLE} text={settings.get(settingsParams.scheduleTitleText)} />
      <List t={t} items={items} />
      <Footer total={total} t={t} navigateToSchedulePage={navigateToSchedulePage} />
    </div>
  ) : null
}
